module.exports = __webpack_public_path__ + "img/valuationResult.f2819a9f.png";